import { render, staticRenderFns } from "./agreement.html?vue&type=template&id=74ad4b9e&"
import script from "./agreement.js?vue&type=script&lang=js&"
export * from "./agreement.js?vue&type=script&lang=js&"
import style0 from "./agreement.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/fintopia-web7chz7/fintopia-web-ci/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74ad4b9e')) {
      api.createRecord('74ad4b9e', component.options)
    } else {
      api.reload('74ad4b9e', component.options)
    }
    module.hot.accept("./agreement.html?vue&type=template&id=74ad4b9e&", function () {
      api.rerender('74ad4b9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/easycash-indo/webview/agreement/agreement.vue"
export default component.exports